import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, PhoneIcon, TargetIcon, HomeIcon, UsersIcon, CalendarIcon, ClipboardCheckIcon, TrendingUpIcon, CheckCircleIcon, SunriseIcon, SunIcon, SunsetIcon } from 'lucide-react';
interface Activity {
  icon: any;
  title: string;
  description: string;
}
interface TimeOfDay {
  id: string;
  label: string;
  icon: any;
  activities: Activity[];
}
const timeOfDayData: TimeOfDay[] = [{
  id: 'morning',
  label: 'Dimineața',
  icon: SunriseIcon,
  activities: [{
    icon: FileTextIcon,
    title: 'Review și Planificare',
    description: 'Verifici platforma, răspunzi la mesaje și planifici vizionările zilei'
  }, {
    icon: PhoneIcon,
    title: 'Apeluri Prospectare',
    description: 'Contactezi proprietari din listele tale pentru a prelua colaborări noi'
  }, {
    icon: TargetIcon,
    title: 'Calificare Clienți',
    description: 'Discuți cu potențiali chiriași/cumpărători și stabilești cerințe'
  }]
}, {
  id: 'afternoon',
  label: 'După-amiază',
  icon: SunIcon,
  activities: [{
    icon: HomeIcon,
    title: 'Vizionări Programate',
    description: 'Conduci vizionări pentru clienți calificați la proprietăți potrivite'
  }, {
    icon: UsersIcon,
    title: 'Întâlniri Proprietari',
    description: 'Te întâlnești cu proprietari pentru semnarea contractelor de colaborare'
  }, {
    icon: CalendarIcon,
    title: 'Programare Follow-up',
    description: 'Organizezi vizionări și follow-up pentru zilele următoare'
  }]
}, {
  id: 'evening',
  label: 'Seara',
  icon: SunsetIcon,
  activities: [{
    icon: ClipboardCheckIcon,
    title: 'Actualizare Platformă',
    description: 'Introduci proprietăți noi și actualizezi statusul tranzacțiilor'
  }, {
    icon: TrendingUpIcon,
    title: 'Analiză Performanță',
    description: 'Revizuiești rezultatele zilei și stabilești obiective'
  }, {
    icon: CheckCircleIcon,
    title: 'Pregătire Zi Următoare',
    description: 'Planifici activitățile și prioritățile pentru mâine'
  }]
}];
export function DayInLifeSection() {
  const [activeTab, setActiveTab] = useState('morning');
  const currentTimeOfDay = timeOfDayData.find(t => t.id === activeTab)!;
  return <div className="w-full bg-gradient-to-br from-[#132C53] to-[#1e4278] py-12 sm:py-16 px-4" data-id="element-913">
      <div className="max-w-5xl mx-auto" data-id="element-914">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-6 sm:mb-8" data-id="element-915">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-2 sm:mb-3 px-4" data-id="element-916">
            O Zi din Viața unui Agent
          </h2>
          <p className="text-gray-300 text-base sm:text-lg px-4" data-id="element-917">
            Descoperă cum arată o zi tipică de lucru în ecosistemul
            Cautlocuință.ro
          </p>
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="flex flex-col sm:flex-row justify-center space-y-2 sm:space-y-0 sm:space-x-2 mb-6 sm:mb-8" data-id="element-918">
          {timeOfDayData.map(timeOfDay => {
          const Icon = timeOfDay.icon;
          return <button key={timeOfDay.id} onClick={() => setActiveTab(timeOfDay.id)} className={`flex items-center justify-center space-x-2 px-4 sm:px-6 py-3 rounded-lg font-medium transition-all ${activeTab === timeOfDay.id ? 'bg-white text-[#132C53] shadow-lg' : 'bg-white bg-opacity-20 text-white hover:bg-opacity-30'}`} data-id="element-919">
                <Icon className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-920" />
                <span className="text-sm sm:text-base" data-id="element-921">{timeOfDay.label}</span>
              </button>;
        })}
        </motion.div>
        <motion.div key={activeTab} initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4
      }} className="bg-white rounded-xl sm:rounded-2xl p-4 sm:p-6 md:p-8 shadow-2xl" data-id="element-922">
          <div className="space-y-4 sm:space-y-6" data-id="element-923">
            {currentTimeOfDay.activities.map((activity, index) => {
            const Icon = activity.icon;
            return <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              duration: 0.4,
              delay: index * 0.1
            }} className="flex flex-col sm:flex-row items-start space-y-3 sm:space-y-0 sm:space-x-4" data-id="element-924">
                  <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-[#357BEB] rounded-xl flex items-center justify-center" data-id="element-925">
                    <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-white" data-id="element-926" />
                  </div>
                  <div className="flex-1 w-full" data-id="element-927">
                    <h3 className="text-base sm:text-lg font-bold text-[#132C53] mb-1" data-id="element-928">
                      {activity.title}
                    </h3>
                    <p className="text-gray-600 text-sm" data-id="element-929">
                      {activity.description}
                    </p>
                  </div>
                </motion.div>;
          })}
          </div>
        </motion.div>
      </div>
    </div>;
}